import { useEffect, useState } from "react";
import { api } from "../../lib/api";

/**
 * Checklist of mechanically-enforced optional rules for a campaign's system (PF2e or D&D 5e).
 * Used both at game creation and later from GM Tools to flip house rules on/off.
 */
export function VariantRulesEditor({ system, value, onChange }) {
  const [catalog, setCatalog] = useState([]);

  useEffect(() => {
    if (system !== "pf2e" && system !== "dnd5e") {
      setCatalog([]);
      return;
    }
    api.get("/games/variant-rules-catalog", { params: { system } }).then((r) => setCatalog(r.data));
  }, [system]);

  if (catalog.length === 0) return null;

  return (
    <div className="space-y-2" data-testid="variant-rules-editor">
      <p className="text-xs uppercase tracking-wider text-[#f1e0c5]/50">Variant Rules (Optional House Rules)</p>
      {catalog.map((rule) => (
        <label key={rule.id} data-testid={`variant-rule-${rule.id}`} className="flex items-start gap-2 bg-black/20 rounded-lg px-3 py-2 cursor-pointer">
          <input
            type="checkbox"
            checked={!!value?.[rule.id]}
            onChange={(e) => onChange({ ...value, [rule.id]: e.target.checked })}
            className="accent-[#D90429] mt-0.5"
          />
          <div>
            <p className="text-sm">{rule.name}</p>
            <p className="text-[10px] text-[#f1e0c5]/40">{rule.description}</p>
          </div>
        </label>
      ))}
    </div>
  );
}
